module.exports = __webpack_public_path__ + "static/img/resetcode.7384d12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resetcode.jpg
// module id = GSIF
// module chunks = 190